import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const receiptTabDetail = defineAsyncComponent(() => import('@/views/receipt/receipt/ReceiptTabDetail.vue'));
const receiptVoucherDetail = defineAsyncComponent(() => import('@/views/receipt/receipt/ReceiptVoucherDetail.vue'));
const receiptSummaryDetail = defineAsyncComponent(() =>
  import('@/views/receipt/receiptSummary/ReceiptSummaryDetail.vue'),
);

const receiptSummarySelect = defineAsyncComponent(() =>
  import('@/views/receipt/receiptSummary/ReceiptSummarySelect.vue'),
);

const restoreVoucherList = defineAsyncComponent(() =>
  import('@/views/system/restoreVoucher/RestoreVoucherList.vue'),
);

export function registerE(app) {
  const registerConfig = {
    ReceiptTabDetail: receiptTabDetail,
    ReceiptVoucherDetail: receiptVoucherDetail,
    ReceiptSummaryDetail: receiptSummaryDetail,
    ReceiptSummarySelect: receiptSummarySelect,
    RestoreVoucherList: restoreVoucherList
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Receipt');
}
